import { render, staticRenderFns } from "./PipelineTabPhaseCategory.vue?vue&type=template&id=9b22335a&"
import script from "./PipelineTabPhaseCategory.vue?vue&type=script&lang=ts&"
export * from "./PipelineTabPhaseCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports